<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Firmware Update</h1>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="firmwareUpdate">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-body">
              <div id="accordion">
                <div class="card">
                  <span
                    class="btn btn-link"
                    data-toggle="collapse"
                    data-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Collapsible Group Item #1
                  </span>
                  <div
                    id="collapseOne"
                    class="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    <p>First Panel</p>
                  </div>
                </div>
                <div class="card">
                  <span
                    class="btn btn-link collapsed"
                    data-toggle="collapse"
                    data-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Collapsible Group Item #2
                  </span>
                  <div
                    id="collapseTwo"
                    class="collapse"
                    data-parent="#accordion"
                  >
                    <p>Second Panel</p>
                  </div>
                </div>
                <div class="card">
                  <span
                    class="btn btn-link collapsed"
                    data-toggle="collapse"
                    data-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    Collapsible Group Item #3
                  </span>
                  <div
                    id="collapseThree"
                    class="collapse"
                    data-parent="#accordion"
                  >
                    <p>Third Panel</p>
                  </div>
                </div>
                <div class="d-none d-sm-inline-flex">
                  <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                      <a
                        class="nav-link active"
                        data-toggle="tab"
                        href="#tabs-1"
                        role="tab"
                        >First Panel</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        data-toggle="tab"
                        href="#tabs-2"
                        role="tab"
                        >Second Panel</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        data-toggle="tab"
                        href="#tabs-3"
                        role="tab"
                        >Third Panel</a
                      >
                    </li>
                  </ul>
                </div>
                <!-- Tab panes -->
                <div class="tab-content">
                  <span
                    class="btn btn-link collapsed d-block d-sm-none"
                    data-toggle="collapse"
                    data-target="#tabs-1"
                    aria-expanded="false"
                  >
                    Collapsible Group Item #1
                  </span>
                  <div
                    class="tab-pane default show"
                    id="tabs-1"
                    data-parent="#accordion"
                  >
                    <p>First Panel</p>
                  </div>
                  <span
                    class="btn btn-link collapsed d-block d-sm-none"
                    data-toggle="collapse"
                    data-target="#tabs-2"
                    aria-expanded="false"
                  >
                    Collapsible Group Item #2
                  </span>
                  <div class="tab-pane" id="tabs-2" data-parent="#accordion">
                    <p>Second Panel</p>
                  </div>
                  <div class="tab-pane" id="tabs-3">
                    <p>Third Panel</p>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-8">
                  <p class="text-muted">
                    <strong><i class="far fa-clipboard"></i> Note:</strong> You
                    may experience temporary loss in connectivity while the
                    system updates your Audra device. Once the update is
                    complete, you might have to login to your Audra local panel
                    and re-configure your internet/WAN settings from
                    <strong>local.audra.io</strong>.
                  </p>

                  <div class="section update-info">
                    <h5>
                      <strong>Current Firmware Version :</strong>
                      <span id="current_version">{{ pre.curVesion }}</span>
                    </h5>
                    <h5>
                      <strong>New Firmware Version :</strong>
                      <span id="new_version">{{ pre.newVesion }}</span>
                    </h5>
                  </div>
                  <br />
                  <div
                    class="error-message"
                    v-if="pandingChangeLog > 0"
                    style="
                      color: #499980;
                      font-size: 22px;
                      text-align: left;
                      font-weight: bold;
                    "
                  >
                    Please wait. The Firewall update is in processing.
                  </div>

                  <div
                    class="error-message"
                    v-else-if="isAvailable <= 0"
                    style="
                      padding-top: 30px;
                      color: #499980;
                      font-size: 18px;
                      text-align: left;
                      font-weight: bold;
                    "
                  >
                    You already have the latest firmware
                  </div>

                  <div v-else-if="isAvailable > 0">
                    From local.audra.io : Device Login >> (Being connected to
                    Audra)<br />
                    From local.audra.io > Device Login<br />
                    1. UPDATE FIRMWARE<br />
                    2. Click update Now<br />
                    3. Wait for the process to complete<br /><br />

                    <div class="btn-area single-btn">
                      <a
                        style="
                          font-size: 20px;
                          border: solid 2px #00a79c;
                          max-width: 310px;
                        "
                        target="blank"
                        href="https://www.youtube.com/watch?v=fg86AFPs9jA&list=PLe0hT-_4TF9G3y1c45N8p16M5DwvFos3A&index=9"
                      >
                        <i class="fab fa-youtube"></i> Watch how we do it
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-footer">
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="isSubmit || disableSubmitButton"
              >
                {{ isSubmit ? 'Please Wait...' : 'Submit' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { CommonAPI } from '@/services/api'
import LocalStorage from '@/services/localStorage'
import axios from 'axios'

export default {
  name: 'RebootForm',
  metaInfo: {
    title: 'Reboot | Dotlines'
  },
  components: {},
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    isSubmit: false,
    params: {},
    accountId: '',
    pre: {
      audraName: [],
      curVesion: '6.0.0',
      newVesion: '5.0.0'
    },
    pandingChangeLog: 0,
    isAvailable: 1
  }),

  methods: {
    handleSubmission () {
      const _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          _this.isSubmit = true
          _this.$swal
            .fire({
              title: 'Are you sure to reboot?',
              text: '',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Reboot'
            })
            .then(result => {
              if (result.isConfirmed) {
                _this.isSubmit = true
                axios
                  .post('/addReboot', {
                    accountId: _this.accountId
                  })
                  .then(response => {
                    _this.$toaster.success(response.data.message)
                  })
                  .catch(error => {
                    console.log(error)
                    _this.$swal.fire('Failed!', 'failed to reboot.', 'error')
                  })
                  .finally(() => {
                    _this.isSubmit = false
                  })
              }
            })
        }
      })
    },

    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      await CommonAPI.getAudraName(LocalStorage.get('accountId'))
        .then(response => {
          this.pre.audraName = response
        })
        .catch(error => {
          console.log(error.response)
        })

      this.getVersionInfo()

      this.is_loading = false

      this.updateLayout()
      $(window).resize(() => {
        this.updateLayout()
      })
    },

    updateLayout () {
      if ($(window).width() < 800) {
        const tab_pane = $('.tab-pane')
        tab_pane.removeClass('tab-pane active').addClass('collapse')
      } else {
        const tab_pane = $('.tab-pane')
        tab_pane.removeClass('collapse show').addClass('tab-pane')
        $('.default').addClass('active')
      }
    },

    convertVersionToInt (version) {
      const versionParts = version.split('.').map(part => parseInt(part, 10))
      return versionParts.reduce(
        (acc, val, index) => acc + val * Math.pow(100, 2 - index),
        0
      )
    },

    getVersionInfo: function () {
      axios
        .get('get-version-info', {
          params: {
            accountId: LocalStorage.get('accountId'),
            deviceType: LocalStorage.get('deviceType')
          }
        })
        .then(response => {
          const data = response.data.split('|')
          this.pre.curVesion = data[0]
          this.pre.newVesion = data[1]
          this.isAvailable = data[2]
          this.pandingChangeLog = data[3]
          console.local(data[2])
        })
        .catch(error => {
          console.log('error ' + error)
        })
        .finally(() => {})
    }
  },

  computed: {
    disableSubmitButton () {
      /* return this.pre.newVesion <= this.pre.curVesion; */
      return true
    }
  },

  mounted () {
    this.initialize()
  }
}
</script>

<style scoped>
/* @media (min-width: 768px) {
  .accordion {
    display: none;
  }
}

@media (max-width: 767.98px) {
  .nav-tabs,
  .tab-content {
    display: none;
  }
} */
</style>
